module.exports = ".chip {\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    padding: 5px;\r\n    border-radius: 25px;\r\n    margin: 0;\r\n    border-width: 2px;\r\n    border-style: solid;\r\n    width: 50%;\r\n    min-width: 180px;\r\n}\r\n\r\n.badge {\r\n    margin-right: 10px;\r\n    padding: 10px;\r\n    line-height: 5px;\r\n    border-radius: 25px;\r\n    text-align: center;\r\n    width: 24px;\r\n    display: inline-block;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./client/app/activities/daily-activities/activity-selector.component.css
// module id = 1262
// module chunks = 1